var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React, { forwardRef } from 'react';
import { LinkOnComponent } from 'app/components/links/link';
import styled from 'styled-components';
import { SIZES } from '@fupa/fupa-uikit';
const LinkContainer = styled(LinkOnComponent).withConfig({
  componentId: "sc-1jgx7lj-0"
})(["min-width:", ";display:flex;align-items:center;justify-content:space-between;padding:", ";", ""], SIZES['84'], SIZES['2'], props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-width: unset;\n    padding: ", ";\n  "])), SIZES['4']));
const Container = styled.div.withConfig({
  componentId: "sc-1jgx7lj-1"
})(["min-width:", ";display:flex;align-items:center;justify-content:space-between;padding:", ";", ""], SIZES['84'], SIZES['2'], props => props.theme.desktopLayout(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    min-width: unset;\n    padding: ", ";\n  "])), SIZES['4']));
const MatchScoreContainer = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    link
  } = _ref;
  if (link) {
    return /*#__PURE__*/React.createElement(LinkContainer, {
      to: link,
      ref: ref
    }, children);
  }
  return /*#__PURE__*/React.createElement(Container, {
    ref: ref
  }, children);
});
export default MatchScoreContainer;